module.exports = __webpack_public_path__ + "img/sharecopy.db667771.svg";